import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function AboutCompanySection() {
    const { t } = useTranslation();

    return (
        <section className="relative py-16 bg-gradient-to-b from-gray-100 to-white">
            <div className="container mx-auto px-4">
                <h2 className="mx-auto text-4xl font-bold text-[#E56820] border-b-4 border-[#E56820] w-fit mb-6">
                    {t("About Company")}
                </h2>
                <div className="f-col flex items-center gap-8">
                    <div className="w-100 w-[50%]">
                        <div className="flex flex-col gap-[12px] bg-white shadow-lg rounded-lg p-6 text-lg leading-relaxed">
                            <div className="flex flex-col gap-[8px]">
                                <p className="font-bold">{t("Hadaret Al-Buruj Plastic Industries Co. (LLC)")}</p>
                                <p className="mt-4">{t("Established in 2023, the company was founded with a clear vision for its economic activity and the foundation upon which it would build its presence in the economic sector of the Hashemite Kingdom of Jordan.")}</p>
                                <p className="mt-4">{t("The company’s main location was strategically chosen within the Madaba Industrial City – operated by the Industrial Cities Company, as part of the development zones aimed at distributing economic infrastructure to less privileged areas.")}</p>
                            </div>
                            <Link
                                to="/about"
                                className="w-full text-center mx-auto bg-[#e56820] text-white px-[30px] py-2 rounded font-bold"
                            >
                                {t("Learn More")}
                            </Link>
                        </div>
                    </div>
                    <div className="w-100 w-[50%] h-[415px]">
                        <img
                            src={require("../../assets/image/comp.JPG")}
                            alt={t("company_image")}
                            className="w-full h-full object-cover rounded-lg shadow-lg transform transition-transform duration-300"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
}